import {
  CalendarDaysIcon,
  CheckIcon,
  ExclamationTriangleIcon,
  PlusIcon,
  TrashIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import ArrowCircleRightSharp from "@mui/icons-material/ArrowCircleRightSharp";

// Icons depending on action
export const historyActionTypes = {
  tripletex_retry: { icon: ArrowCircleRightSharp, bgColorClass: "bg-sky-400" },
  "create": { icon: PlusIcon, bgColorClass: "bg-green-400" },
  "update": { icon: CheckIcon, bgColorClass: "bg-blue-400" },
  "destroy": { icon: TrashIcon, bgColorClass: "bg-red-400" },
  "status_update": { icon: CheckIcon, bgColorClass: "bg-yellow-400" },
  "link_work_order": { icon: CheckIcon, bgColorClass: "bg-indigo-400" },
  "unlink_work_order": { icon: XCircleIcon, bgColorClass: "bg-gray-400" },
  "sync_from_work_order": { icon: ArrowCircleRightSharp, bgColorClass: "bg-blue-400" },
  "send_notification": { icon: CheckIcon, bgColorClass: "bg-emerald-400" },
  "send_notification_scheduled": { icon: CalendarDaysIcon, bgColorClass: "bg-amber-400" },
  "send_notification_failed": { icon: ExclamationTriangleIcon, bgColorClass: "bg-red-400" },
  "process": { icon: CheckIcon, bgColorClass: "bg-purple-400" },
  "update_after_process": { icon: ExclamationTriangleIcon, bgColorClass: "bg-yellow-400" },
  "new_agreement": { icon: CalendarDaysIcon, bgColorClass: "bg-pink-400" },
  "sync_error": {
    icon: ExclamationTriangleIcon,
    bgColorClass: "bg-red-400",
  },
  "sync_api": { icon: ArrowCircleRightSharp, bgColorClass: "bg-blue-400" },
  "tripletex_sync_attempt": {
    icon: ArrowCircleRightSharp,
    bgColorClass: "bg-sky-400",
  },
  "tripletex_sync": { icon: CheckIcon, bgColorClass: "bg-emerald-500" },
  "tripletex_sync_skipped": {
    icon: ExclamationTriangleIcon,
    bgColorClass: "bg-amber-500",
  },
  "request_agreed_overtime": {
    icon: ExclamationTriangleIcon,
    bgColorClass: "bg-amber-500",
  },
  "confirm_agreed_overtime": {
    icon: CheckIcon,
    bgColorClass: "bg-emerald-500",
  },
  "reject_agreed_overtime": {
    icon: XCircleIcon,
    bgColorClass: "bg-red-400",
  },
  lock: { icon: ExclamationTriangleIcon, bgColorClass: "bg-red-500" },
  unlock: { icon: CheckIcon, bgColorClass: "bg-emerald-500" },
  not_approved_notification: {
    icon: CheckIcon,
    bgColorClass: "bg-rose-400",
  },
  approved_notification: {
    icon: CheckIcon,
    bgColorClass: "bg-emerald-400",
  },
  send_email: {
    icon: CheckIcon,
    bgColorClass: "bg-emerald-400",
  },
};

export const historyControllers = {
  "user": "users",
  "report": "rapport",
  "order": "ordre",
  "tripletex_api": "- Tripletex API",
};

export const historyActions = {
  tripletex_retry: "satte Tripletex-synkronisering i kø på nytt for",
  "processed": "behandlet",
  "process": "behandlet",
  "update": "oppdatert",
  "status_update": "oppdatert status på",
  "link_work_order": "knyttet arbeidsordre til",
  "unlink_work_order": "fjernet arbeidsordre fra",
  "sync_from_work_order": "synkronisert fra arbeidsordre for",
  "send_notification": "sendt varsel om",
  "send_notification_scheduled": "planla varsel om",
  "send_notification_failed": "sending av varsel feilet for",
  "update_after_process": "oppdatert etter behandling",
  "create": "opprettet",
  "destroy": "fjernet",
  "new_agreement": "updated date agreement for",
  "new_message": "sendt en SMS",
  "answer": "mottatt svar fra kunde",
  "update_product": "updated",
  "sync_error":
    "prøvd å synkronisere ordre, men det skjedde et Synkroniseringsfeil",
  "sync_success": "Utført synkronisering og det var vellykket",
  "sync_api": "utført synkronisering av",
  "tripletex_sync_attempt": "Tripletex-synk forsøkt for",
  "tripletex_sync": "Tripletex-synk fullført for",
  "tripletex_sync_skipped": "Tripletex-synk hoppet over for",
  "request_agreed_overtime": "forespurte avtalt overtid på",
  "confirm_agreed_overtime": "bekreftet avtalt overtid på",
  "reject_agreed_overtime": "avviste avtalt overtid på",
  lock: "låste",
  unlock: "låste opp",
  not_approved_notification: "sendte e-post: ikke godkjent for",
  approved_notification: "sendte e-post: godkjent for",
  send_email: "sendte referat til",
};
